var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"active-side"},[_c('img',{staticClass:"info",attrs:{"src":require("@/assets/image/action-side/pc/info.png")}}),_c('br'),_c('img',{staticClass:"close",attrs:{"src":require("@/assets/image/action-side/pc/close.png")},on:{"click":function($event){_vm.visible = false}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }